import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Subscription} from "rxjs";
import * as fromStore from '../../../store';
import {Store} from '@ngrx/store';
import {Website} from "../website";
import {User} from "../../../user/user";
import {DialogService} from "../../../../ng2-bootstrap-modal/dialog.service";
import {UserSubscription} from "../../../user/user-subscription";
import {Observable} from "rxjs";
import {FormControl} from "@angular/forms";

import {SearchByPropertyPipe} from "../../../shared/pipes/search-by-property.pipe";
import {TextUtils} from "../../../shared/utils/text-utils";
import {
  NotificationDialogComponent
} from "../../../shared/components/dialogs/notification-dialog/notification-dialog.component";
import {Utils} from "../../../shared/utils/utils";
import {Config} from "../../../config/config";
import {DbModalService} from "../../../modules/modal/modal";
import {CreateSubSiteComponent} from "../../../components/common/create-subsite/create-sub-site.component";

@Component({
    selector: 'db-my-sites',
    templateUrl: './mySites.component.html',
    styleUrls: ['./mySites.component.scss'],
    standalone: false
})
export class MySitesComponent implements OnInit, OnDestroy {

  private _subscriptions: Subscription[];
  public website: Website;
  public user: User;
  public userSubscription: UserSubscription;
  public websites$: Observable<Website[]>;
  public websites: Website[];
  public networkSubsites: Website[];
  public searchTerm: FormControl;
  public filteredWebsites: Website[];

  constructor(
    private _searchPipe: SearchByPropertyPipe,
    private _router: Router,
    private _route: ActivatedRoute,
    private _store: Store<fromStore.DbStoreState>,
    private _dialogService: DialogService,
    private _modalService: DbModalService,
  ) {}

  ngOnInit() {
    this.searchTerm = new FormControl('');
    this.userSubscription = this._route.snapshot.data['userSubscription'];
    this.user = this._route.snapshot.data['user'];
    this.website = this._route.snapshot.parent.data['website'];
    this.websites$ = <any>this._store.select(fromStore.getWebsites);
    this.websites$.subscribe((websites: Website[]) => {
      this.websites = websites.filter((website: Website) => website.type === 'live' && website.isNetwork && website.parentId && website.parentId === this.website.id);
      this.networkSubsites = this.websites;
      this.filteredWebsites = <Website[]>this._searchPipe.transform(this.networkSubsites, {'site_url': this.searchTerm.value, 'title': this.searchTerm.value});
    });
    this.addEventHandlers();
    this.searchTerm.valueChanges.subscribe((): void => {
      this.filterWebsites();
    });

  }

  ngOnDestroy() {
    this.removeEventHandlers();
  }

  private addEventHandlers(): void {
    this._subscriptions = [];

  }

  private removeEventHandlers(): void {
    this._subscriptions.forEach((subscription: Subscription): void => {
      subscription.unsubscribe();
    });
    this._subscriptions = null;
  }

  public websiteTrackBy(index: number, website: Website) {
    return website.id;
  }

  public addWebsiteDialog(): void {
    if (this.website.multisiteType === 'subdomain' && Utils.checkStringInArray(this.website.site_url, Config.hostnameList)) {
      this._dialogService
        .addDialog(NotificationDialogComponent, {
          header: TextUtils.getText('text_multisiteAddSiteWithoutPointingDomainTitle'),
          message: TextUtils.getText('text_multisiteAddSiteWithoutPointingDomainDesc'),
          buttonText: TextUtils.getText('text_multisiteAddSiteWithoutPointingDomainBtn'),
          buttonColor: 'blue',
          showCancelButton: true,
          action: 'point-domain'
        })
        .subscribe((confirmed: string|boolean) => {
          if (confirmed && confirmed === 'point-domain') {
            this._router.navigate(['/websites/' + this.filteredWebsites[0].id + '/domains']);
          }
        });
    }
    else {
      const modal = this._modalService.open(CreateSubSiteComponent, {backdrop: 'static'});
      modal.componentInstance.websiteId = this.website.id;
      modal.componentInstance.isSubDomain = this.website.multisiteType === 'subdomain';
      modal.componentInstance.parentUrl = this.website.site_url.replace(/^https?:\/\//i, '');
    }
  }

  public filterWebsites() {
    const websiteList = this.networkSubsites;
    this.filteredWebsites = <Website[]>this._searchPipe.transform(websiteList, {'site_url': this.searchTerm.value, 'title': this.searchTerm.value});
  }

}
